import axios from "axios";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form"];

  connect() {
    this.loadChart();
  }

  loadChart() {
    const form = this.formTarget;
    let url = this.data.get("url");
    let chartPanelId = "#" + this.data.get("chart-panel-id");

    showLoaderPanel(chartPanelId);

    axios
      .get(url, { params: getFormData($(form)) })
      .then(response => {
        const data = response.data;

        if (data.length == 0) {
          showNoResultsPanel(chartPanelId);
        } else {
          showChartPanel(chartPanelId);
          let type = this.data.get("type");
          switch (type) {
            case "time-spent":
              initTimeSpentStatisticsChart(data);
              break;
            case "user-activities":
              initUserActivitiesStatisticsChart(data);
              break;
            case "timeline":
              initBrandsTimelineStatisticsChart(data, type);
              break;
          }
        }
      })
      .catch(error => {
        showCardLoadError(this.element, error);
      });
  }
}
